import React from 'react';
import { Link } from 'react-router-dom';

const About = () => (
  <div className="about">
    <Link to="/" className="about__close">
      <i className="icon icon--close"></i>
    </Link>

    <div className="about__intro">
      <div className="about__intro-title">Wolfgang Ganter</div>
      <div className="about__intro-subtitle">*1978 in Stuttgart, lives in Berlin (D)</div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Education</h2>
      <div className="about__row-item">
        <p>1999 – 2004</p>
        <p>Studies of Fine Arts, Staatliche Akademie der Bildenden Künste Karlsruhe (D), Prof. Andreas Slominski and Anselm Reyle</p>
      </div>
      <div className="about__row-item">
        <p>2004 – 2005</p>
        <p>Masterclass Prof. Andreas Slominski</p>
      </div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Awards / Scholarships / Residencies (Selection)</h2>
      <div className="about__row-item">
        <p>2018</p>
        <p>Residency at the Australia China Art Foundation, Shanghai (CHN)</p>
      </div>
      <div className="about__row-item">
        <p>2016</p>
        <p>Residency at the Gulbenkian Science Institute (IGC), Lisbon (PRT)</p>
      </div>
      <div className="about__row-item">
        <p>2016</p>
        <p>Residency at the Till Richter Museum, Buggenhagen (D)</p>
        <p>Residency at the Gulbenkian Institue (IGC), Lisbon (PRT)</p>
      </div>
      <div className="about__row-item">
        <p>2015</p>
        <p>Award of the Positions Artfair, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2012</p>
        <p>Stiftung Kunstfonds, scholarship (D)</p>
        <p>Kunststiftung Baden-Württemberg, scholarship (D)</p>
        <p>Wochenaufenthalter 2012, Bureau d´Artiste, Zürich (CH)</p>
      </div>
      <div className="about__row-item">
        <p>2010</p>
        <p>Residency at the Cité Internationale des Arts, Paris (F)</p>
        <p>Residency at the Silvia und Helmut Wickleder Stiftung, Schloss Leinzell (D)</p>
      </div>
      <div className="about__row-item">
        <p>2009</p>
        <p>Residency at the Stiftung Künstlerdorf Schöppingen (D)</p>
      </div>
      <div className="about__row-item">
        <p>2005</p>
        <p>Grant for Postgraduate-Studies, Landesstiftung Baden-Württemberg (D)</p>
        <p>Award of the Förderkreis Kunst und Kultur Offenburg (D)</p>
      </div>
      <div className="about__row-item">
        <p>2004</p>
        <p>Grant of the Heinrich-Herz-Gesellschaft (D)</p>
      </div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Solo Exhibitions (Selection)</h2>
      <div className="about__row-item">
        <p>2018</p>
        <p>Chef d`Oeuvre Brisé, Ambacher Contemporary, München (D)</p>
        <p>Olsson Gallery, Stockholm (SE)</p>
        <p>Burster Gallery, Berlin (D)</p>
        <p>Belo-Galsterer Gallery, Lisbon (PRT)</p>
        <p>Zwischenwelt (with Kamil Rongen), Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2017</p>
        <p>Gallery of the College of Staten Island, New York City, (USA)</p>
        <p>Rockefeller University, New York City, (USA)</p>
        <p>Chef d`Oeuvre Brisé, Ambacher Contemporary, Paris (FRA)</p>
      </div>
      <div className="about__row-item">
        <p>2016</p>
        <p>Regeneratio, Berlin Hyp, Berlin (D)</p>
        <p>BioHazard, Till Richter Museum, Buggenhagen (D)</p>
      </div>
      <div className="about__row-item">
        <p>2015</p>
        <p>Burster Gallery, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2014</p>
        <p>Afterglow, Maerzgalerie, Leipzig (D)</p>
        <p>Six Masterpieces, Olsson Gallery (SE)</p>
        <p>Bactereality, Städtische Galerie Tuttlingen (D)</p>
        <p>Non Finito, Maerzgalerie, Leipzig (D)</p>
      </div>
      <div className="about__row-item">
        <p>2013</p>
        <p>transPORT, Westwerk, Hamburg (D)</p>
        <p>Misremember, Cityhall Stuttgart (D)</p>
        <p>Aided Recall, Kunstforum Weil der Stadt (D)</p>
        <p>Decomposizione, Kunststiftung Baden Württemberg (D)</p>
      </div>
      <div className="about__row-item">
        <p>2012</p>
        <p>Bakterialität, Olsson Gallery, Stockholm (SE)</p>
        <p>Informel Logic, Eli Ridgway Gallery, San Francisco (USA)</p>
      </div>
      <div className="about__row-item">
        <p>2011</p>
        <p>Inside, Inside, Cultuurwerf, Flushing (NL)</p>
      </div>
      <div className="about__row-item">
        <p>2009</p>
        <p>Accidentanalysis, Maud Piquion, Berlin (D)</p>
        <p>Sunscreen, Ferenbalm-Gurbü Station, Karlsruhe (D)</p>
      </div>
      <div className="about__row-item">
        <p>2008</p>
        <p>Seasick, Baer Ridgway Exhibitions, San Francisco (USA)</p>
        <p>Orbis Tertius, Ferenbalm-Gurbü Station Karlsruhe (D)</p>
      </div>
      <div className="about__row-item">
        <p>2006</p>
        <p>Shake Hands, Artforum, Förderkreis Kunst und Kultur Offenburg (D)</p>
      </div>
      <div className="about__row-item">
        <p>2005</p>
        <p>Der Tod ist kein Beinbruch, Galerie Karlheinz Meyer, Karlsruhe (D)</p>
      </div>
      <div className="about__row-item">
        <p>2002</p>
        <p>Latenight, Glashaus, Durlach (D)</p>
      </div>
      <div className="about__row-item">
        <p>2001</p>
        <p>Bo Ta Nik, Poly, Produzentengalerie Karlsruhe (D)</p>
      </div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Group Exhibitions (Selection)</h2>
      <div className="about__row-item">
        <p>2017</p>
        <p>Compose, Recompose, Decompose, Jules Maeght Gallery, San Francisco (USA)</p>
        <p>Focus Berlin, Till Richter Museum, Buggenhagen (D)</p>
        <p>Homecoming, Luis Leu, Karlsruhe (D)</p>
      </div>
      <div className="about__row-item">
        <p>2016 – 2017</p>
        <p>Panorama, Contemporary Art Museum, Collection Hurrle, Durbach (D)</p>
      </div>
      <div className="about__row-item">
        <p>2016</p>
        <p>The End, Let´s start again, Donau83, Berlin (D)</p>
        <p>Liaison, Uferhallen, Berlin (D)</p>
        <p>Erste Botschaft: Frohe Botschaft, Botschaft, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2015</p>
        <p>Showcase, Maerzgalerie, Leipzig (D)</p>
        <p>Kunsttour 2015, Kunststiftung Baden-Württemberg (D)</p>
      </div>
      <div className="about__row-item">
        <p>2014</p>
        <p>Zum Zufall, Kunstverein Potzdam, (D)</p>
      </div>
      <div className="about__row-item">
        <p>2013</p>
        <p>Anna Ly Sing, Performance and Exhibition with Gelatin, Schinkel Pavillion, Berlin (D)</p>
        <p>Status 2, Künstlerhaus Bethanien, Berlin (D)</p>
        <p>Sezession, SEZ, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2010</p>
        <p>My favorite Works, Kinosho Kikaku Fine Arts Modern &amp; Contemporary, Tokyo (JPN)</p>
        <p>Ein Fest für Boris (1.+2. Akt ), Vittorio Manalese, Berlin (D)</p>
        <p>Making Sense of Waste, Arc Gallery, San Francisco (USA)</p>
      </div>
      <div className="about__row-item">
        <p>2009</p>
        <p>Das Fundament in der Kunst, Städtische Museen Heilbronn (D)</p>
        <p>Big in Japan, Itatoi (JPN)</p>
        <p>Boarderline Pleasure, Galerie Michael Janssen, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2008</p>
        <p>Ready, Set, Go, Baer Ridgway Exhibitions, San Francisco (USA)</p>
        <p>Wilde Hasen, Tape Modern, Go Art, Berlin (D)</p>
        <p>Psycho Berlin, Galerie im Waschhaus, Berlin (D)</p>
        <p>1 A, Studio A, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2007</p>
        <p>Blaue Augen, Showroom Berlin / Inter Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2006</p>
        <p>Leinzell Open again, Silvia und Helmut Wickleder Stiftung Schloss Leinzell (D)</p>
        <p>BoulevArt, Kunstherbst Berlin (D)</p>
        <p>Wir hätten das Land gern weit rund und sie..., Showroom Berlin (D)</p>
        <p>Slices of Life, Ferenbalm-Gurbü Station Karlsruhe (D)</p>
      </div>
      <div className="about__row-item">
        <p>2005</p>
        <p>Leinzell Open, Silvia und Helmut Wickleder Stiftung Schloss Leinzell (D)</p>
        <p>Cabin baggage, Galerie Manuel Garcia, Oaxaca (MEX)</p>
      </div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Works in Public Space (Selection)</h2>
      <div className="about__row-item">
        <p>2015</p>
        <p>Project for the German Red Cross, Carlo Bossoli, The Battle of Solferino (D)</p>
        <p>Public Project, Karlsruhe Institut of Technology (KIT), Flexio Fantasia a Luminis (D)</p>
      </div>
      <div className="about__row-item">
        <p>2012</p>
        <p>Walter Womacka, Arbeit für das Glück des Menschen, Public Project, Art in Public</p>
        <p>Space at the Marzahner Promenade, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2010</p>
        <p>Trash, Contemporary Fine Arts, Sculpture Garden, Frieze Art Fair, London (GB)</p>
      </div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Lectures</h2>
      <div className="about__row-item">
        <p>2018</p>
        <p>One Fine Day, artist workshop, Nairobi (KEN)</p>
        <p>Gulbenkian Museum, Lisbon (PRT)</p>
      </div>
      <div className="about__row-item">
        <p>2017</p>
        <p>School of Molecular and Theoretical Biology, Barcelona (ESP)</p>
        <p>Humbold University, Berlin (D)</p>
      </div>
      <div className="about__row-item">
        <p>2016</p>
        <p>Gulbenkian Science Institute (IGC), Lisbon (PRT)</p>
        <p>Art / Sci Nexus, Kunstkraftwerk, KKW, Leipzig (D)</p>
      </div>
      <div className="about__row-item">
        <p>2010</p>
        <p>Eikones, NCCR Iconic Criticism, Basel (CH)</p>
      </div>
    </div>

    <div className="about__row">
      <h2 className="about__row-title">Public Collections</h2>
      <div className="about__row-item">
        <p>Städtische Museen Heilbronn (D)</p>
        <p>Museum der Moderne Salzburg (AUT)</p>
        <p>Silvia und Helmut Wickleder Stiftung Schloss Leinzell (D)</p>
        <p>Museum für aktuelle Kunst, Durbach (D)</p>
        <p>Koc Foundation, Istanbul (TUR)</p>
        <p>Till Richter Museum, Buggenhagen (D)</p>
        <p>Olbricht Foundation, Berlin (D)</p>
        <p>Martha und Paul Rauert Collection, Hamburg (D)</p>
      </div>
    </div>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/views/about/index.js